module.exports = __webpack_public_path__ + "img/Corner.c15692ee.png";